import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCachingService } from './image-caching-service/image-caching-service.service';

@NgModule({
  imports: [CommonModule],
  providers: [ImageCachingService],
})
export class SharedServicesModule {}
